import gt from 'lodash/gt';
import lte from 'lodash/lte';
import zip from 'lodash/zip';
import cond from 'lodash/cond';
import constant from 'lodash/constant';
import { FIRST_PAGE } from '../../Serp/components/shared/Pager/constants';
import { TOTAL_RESULTS_FIRST_THRESHOLD, TOTAL_RESULTS_SECOND_THRESHOLD } from './constants';

function getPositionRangesByThreshold(totalOrganicResults, totalAdsPerSection) {
  return cond(
    zip(
      [
        constant(lte(totalOrganicResults, TOTAL_RESULTS_FIRST_THRESHOLD)),
        constant(
          gt(totalOrganicResults, TOTAL_RESULTS_FIRST_THRESHOLD) &&
            lte(totalOrganicResults, TOTAL_RESULTS_SECOND_THRESHOLD)
        ),
        constant(gt(totalOrganicResults, TOTAL_RESULTS_SECOND_THRESHOLD)),
      ],
      totalAdsPerSection
    )
  )();
}

// Premium Ads Rules: https://confluence.services/display/PROD/Organic
function getPositionRanges(totalOrganicResults, page, maxPage) {
  const isLastPage = page === maxPage;
  const isSinglePage = isLastPage && page === FIRST_PAGE;

  if (isSinglePage) {
    return getPositionRangesByThreshold(totalOrganicResults, [
      constant({ top: 0, bottom: 0 }),
      constant({ top: 2, bottom: 0 }),
      constant({ top: 4, bottom: 4 }),
    ]);
  }

  if (isLastPage) {
    return getPositionRangesByThreshold(totalOrganicResults, [
      constant({ top: 4, bottom: 0 }),
      constant({ top: 4, bottom: 4 }),
      constant({ top: 4, bottom: 4 }),
    ]);
  }

  return { top: 4, bottom: 4 };
}

const splitAdsByPosition = (ads, ranges) => {
  if (ads.length > 0) {
    const top = ads.slice(0, ranges.top);
    const bottom = ads.slice(ranges.top, ranges.top + ranges.bottom);
    return { top, bottom };
  }
  return ads;
};

export default function applyPremiumAdsShowingRules(
  premiumAds,
  totalOrganicResults,
  page,
  maxPage
) {
  return splitAdsByPosition(premiumAds, getPositionRanges(totalOrganicResults, page, maxPage));
}



// WEBPACK FOOTER //
// ./app/utils/adNormalizers/applyPremiumAdsShowingRules.js